/**
 * Component Registry for Azure Carnes Crossroads
 * 
 * Inherits from @vibesites-american-landmark/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-american-landmark/theme-preferred/registry';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Example: Override the Footer with a custom component
  // Footer: Footer,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
